/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetArticleModel,
  IGetArticleRequest,
  IMappers,
  IGetArticleResponse,
  IGetArticleResponseError,
  TGetArticleResponse,
} from './types';

const defaultConfig: TGetArticleModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'valuation-b2b',
  pathApi: '/v1/get-article/',
  hostType: 'api',
} as TGetArticleModel;

function createGetArticleModel(parameters: IGetArticleRequest): TGetArticleModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetArticleOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetArticleRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetArticle<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetArticleOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetArticleResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetArticleModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetArticleResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetArticleResponseError);
    }
  }

  return { response, statusCode } as TGetArticleResponse;
}

export { defaultConfig, createGetArticleModel, fetchGetArticle };
